import React, {
  useState,
  useEffect,
  useCallback
} from "react";

import {
  Card,
  List,
  Dimmer,
  Loader,
  Icon,
  Header,
  Button,
} from "semantic-ui-react";

import numeral from "numeral";

import APIService from "../../Services/API/APIService";

import {
  Link,
  useLocation,
  useNavigate,
  useResolvedPath
} from "react-router-dom";

import CheckRoom from "./CheckRoom";

import { toast } from "react-toastify";


const AvailableRooms = () => {


  // ============================================
  // React Router Hooks
  // ============================================

  const location = useLocation();

  const navigate = useNavigate();

  const path = useResolvedPath("").pathname;



  // ============================================
  // Read URL Query Parameters
  //
  // Example:
  //
  // available-rooms?
  // checkin=2026-07-26
  // checkout=2026-07-28
  // locationId=2
  //
  // ============================================


  const searchParams = new URLSearchParams(location.search);


  const checkIn =
    searchParams.get("checkin");


  const checkOut =
    searchParams.get("checkout");


  const locationId =
    searchParams.get("locationId");



  // ============================================
  // Component States
  // ============================================


  const [loading, setLoading] =
    useState(false);


  const [rooms, setRooms] =
    useState([]);




  // ============================================
  // Fetch Available Rooms
  // ============================================


  const fetchData = useCallback(
    async (isSubscribed) => {


      setLoading(true);


      try {


        let result = [];



        // Only call API when checkout exists

        if (checkOut) {


          result =
            await APIService.postDataNoAuth(

              "/guest-house/availableRooms",

              {

                checkin: checkIn,

                checkout: checkOut,


                // Send location ID
                // Example:
                // Lagos = 1
                // Port Harcourt = 2

                locationId: Number(locationId),

              }

            );



          if (isSubscribed) {

            setRooms(result);

          }

        }



        setLoading(false);



      } catch (error) {


        toast.warn(error);


        setLoading(false);


      }


    },

    [
      checkIn,
      checkOut,
      locationId
    ]

  );





  // ============================================
  // Reload rooms when search criteria changes
  // ============================================


  useEffect(() => {


    let isSubscribed = true;


    window.scrollTo(0,0);



    fetchData(isSubscribed);



    return () => {

      isSubscribed = false;

    };


  }, [
    checkIn,
    checkOut,
    locationId,
    fetchData
  ]);





  return (

    <div>



      {/* ==========================
          Loading Screen
          ========================== */}

      {loading && (

        <Dimmer active inverted>

          <Loader>

            Searching Please wait...

          </Loader>

        </Dimmer>

      )}






      {/* ==========================
          No Rooms Found
          ========================== */}


      {
        rooms.length === 0 &&

        (

          <>

            <Header

              as="h2"

              textAlign="center"

              style={{

                backgroundColor:"#26f09e",

                color:"#000000"

              }}

            >

              No Available Rooms

            </Header>



            <CheckRoom path={path}/>


          </>

        )

      }





      {/* ==========================
          Rooms Available
          ========================== */}



      {
        rooms.length > 0 &&


        (

          <Header

            as="h2"

            textAlign="center"

            style={{

              backgroundColor:"#26f09e",

              color:"#000000"

            }}

          >

            Available Rooms


          </Header>


        )

      }





      <Card.Group

        itemsPerRow={3}

        stackable

      >



        {
          rooms?.map((item)=>(



            <Card

              key={item.roomCode}

              color="teal"

              as={Link}


              to={{

                pathname:
                  `../rooms/${item.roomCode}`,

              }}


              fluid


            >




              {/* ======================
                  Room Image
                  ====================== */}


              {
                item.GuestHouseGalleries[0] &&


                (

                  <div


                    style={{


                      backgroundImage:

                        "url(" +

                        item.GuestHouseGalleries[0]
                          ?.resizeLocation +

                        ")",



                      height:400,


                      width:"100%",


                      backgroundRepeat:
                        "no-repeat",


                      backgroundPosition:
                        "center",


                    }}



                  >



                    <Header


                      style={{


                        position:"absolute",


                        backgroundColor:
                        "rgba(38,240,153,0.6)",


                        color:"#000000",


                        padding:"0.3em",


                        borderRadius:"7px"


                      }}


                    >



                      {item.name}


                      <Icon name="" />


                      ₦
                      {numeral(item.price)
                        .format("0,0")}



                    </Header>



                  </div>


                )

              }







              {/* ======================
                  Description
                  ====================== */}


              <Card.Description

                size="large"

                style={{
                  color:"#000"
                }}

              >


                <List

                  horizontal

                  divided

                  size="large"

                >



                  {
                    item.description
                    .split("\n")
                    .map((desc,index)=>(



                      <List.Item

                        key={index}

                      >


                        <List.Content>


                          <Icon

                            name=
                            "arrow alternate circle right"

                          />


                          {desc}


                        </List.Content>



                      </List.Item>



                    ))

                  }



                </List>


              </Card.Description>






              {/* ======================
                  View Room Button
                  ====================== */}



              <Button


                style={{

                  backgroundColor:"#26f09e",

                  color:"#000000"

                }}



                onClick={()=>

                  navigate(
                    `rooms/${item.roomCode}`
                  )

                }


              >


                View Our Deals


              </Button>






            </Card>



          ))

        }



      </Card.Group>




    </div>


  );

};


export default AvailableRooms;